import React from 'react';

export class Header extends React.Component
{
    render() {
      return (
        <header className="app-header">
            <h1 className="header-logo">TigerCity.ai</h1>
        </header>
        );
    }
};

